/**
 * Resolves the active fixed tax rate object during the deploy/migration window.
 * Reads from the new home (eventDetails.fixedTaxRates for events,
 * product.fixedTaxRates for checkouts) first, falls back to the legacy
 * page.tax.fixedTaxRates so unmigrated pages still preview tax correctly.
 *
 * Returns the first hydrated rate object (with `percentage`, `inclusive`,
 * `displayName`, etc.) or null. The fallback branch is removed in the cleanup
 * PR after the migration is verified in prod.
 */
export default function getFixedTaxRate({ page, product }) {
  if (page?.type === 'event') {
    const fromEvent = page?.eventDetails?.fixedTaxRates?.[0];
    if (fromEvent) return fromEvent;
    return page?.tax?.fixedTaxRates?.[0] ?? null;
  }
  const fromProduct = product?.fixedTaxRates?.[0];
  if (fromProduct) return fromProduct;
  return page?.tax?.fixedTaxRates?.[0] ?? null;
}
